module.exports = __webpack_public_path__ + "static/media/standard.ad6ba7cf.png";